import classNames from 'classnames'
import React from 'react'
import MediaItemMediaVideo from 'components/MediaItem/Video'
import Image from 'components/Image'

const MediaItem = React.memo(function MediaItem ({
  mediaItem,
  shouldLazyLoad,
  className
}) {
  const { mediaContentType } = mediaItem
  let element
  if (mediaContentType === 'IMAGE') {
    element = (
      <Image
        src={mediaItem.image?.url}
        alt={mediaItem.alt}
        className={classNames(className, { lazyload: shouldLazyLoad })}
      />
    )
  } else if (mediaContentType === 'VIDEO') {
    element = <MediaItemMediaVideo className={className} mediaItem={mediaItem} />
  }

  return (
    <>
      {element}
    </>
  )
})

export default MediaItem
